// import React, { useState } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { 
//   MagnifyingGlassIcon, 
//   Bars3Icon, 
//   XMarkIcon,
//   CalendarDaysIcon,
//   EnvelopeIcon,
//   GlobeAltIcon,
//   UserGroupIcon,
//   ChevronDownIcon,
//   ChevronRightIcon
// } from '@heroicons/react/24/outline';
// import { useCategories } from '../../hooks/useCategories';
// import udam from '../../images/udam.jpg';
// import acep from '../../images/acep.jpg';

// const Header = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { categories, loading: categoriesLoading } = useCategories();

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (searchTerm.trim()) {
//       navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
//       setSearchTerm('');
//       setIsMenuOpen(false);
//     }
//   };

//   const mainCategories = categories.filter(cat => cat.parent === 0).slice(0, 6);

//   // Partenaires pour le carrousel
//   const partners = [
//     { id: 1, name: "UDAM", logo: udam },
//     { id: 2, name: "ACEP", logo: acep },
//   ];

//   // Dupliquer pour l'effet de boucle infinie
//   const duplicatedPartners = [...partners, ...partners, ...partners];

//   // Fonction pour générer les breadcrumbs
//   const generateBreadcrumbs = () => {
//     const pathSegments = location.pathname.split('/').filter(Boolean);
//     const breadcrumbs = [];

//     if (pathSegments.length > 0) {
//       if (pathSegments[0] === 'category' && pathSegments[1]) {
//         const categoryName = pathSegments[1];
//         const categoryDisplayName = getCategoryDisplayName(categoryName);
//         breadcrumbs.push({
//           name: categoryDisplayName,
//           path: `/category/${categoryName}`
//         });
//       }
//     }

//     return breadcrumbs;
//   };

//   const getCategoryDisplayName = (categorySlug) => {
//     const categoryMap = {
//       'politique': 'Politique',
//       'societe': 'Société',
//       'education': 'Éducation',
//       'religion': 'Religion',
//       'necrologie': 'Nécrologie',
//       'sport': 'Sport',
//       'international': 'International'
//     };
//     return categoryMap[categorySlug] || categorySlug;
//   };

//   const closeMobileMenu = () => {
//     setIsMenuOpen(false);
//     setMobileDropdownOpen(false);
//   };

//   return (
//     <>
//       <style jsx>{`
//         @keyframes scroll {
//           0% {
//             transform: translateX(0);
//           }
//           100% {
//             transform: translateX(-33.333%);
//           }
//         }

//         .animate-scroll {
//           animation: scroll 15s linear infinite;
//         }

//         .animate-scroll:hover {
//           animation-play-state: paused;
//         }
//       `}</style>
      
//       <header className="bg-white shadow-lg fixed w-full top-0 z-50">
//         {/* <header className="bg-white shadow-lg w-full z-50"> */}

//         {/* Section partenaires avec carrousel */}
        
// <div className="bg-gray-50 py-2 shadow-sm overflow-hidden">
//   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//     <div className="flex animate-scroll space-x-8">
//       {/* Dupliquer les partenaires pour l'effet de boucle */}
//       {[...Array(3)].flatMap((_, groupIndex) => [
//         <div key={`udam-${groupIndex}`} className="flex-shrink-0">
//           <img
//             src={udam}
//             alt="Logo UDAM"
//             className="w-32 h-16 sm:w-24 sm:h-20 object-contain transition-all duration-300"
//           />
//         </div>,
//         <div key={`acep-${groupIndex}`} className="flex-shrink-0">
//           <img
//             src={acep}
//             alt="Logo ACEP"
//             className="w-40 h-16 sm:w-32 sm:h-20 object-contain transition-all duration-300"
//           />
//         </div>
//       ])}
//     </div>
//   </div>
// </div>



//         <div className="bg-gradient-to-r from-red-600 via-red-700 to-blue-800 text-white">
//           <div className="container mx-auto px-4 py-2 sm:py-3">
//             <div className="flex justify-between items-center text-xs sm:text-sm">
//               <div className="flex items-center space-x-2 sm:space-x-6">
//                 <div className="flex items-center space-x-1 sm:space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-2 sm:px-3 py-1">
//                   <CalendarDaysIcon className="w-3 h-3 sm:w-4 sm:h-4" />
//                   <span className="font-medium hidden sm:inline">
//                     {new Date().toLocaleDateString('fr-FR', { 
//                       weekday: 'long', 
//                       year: 'numeric', 
//                       month: 'long', 
//                       day: 'numeric' 
//                     })}
//                   </span>
//                   <span className="font-medium sm:hidden">
//                     {new Date().toLocaleDateString('fr-FR', { 
//                       day: 'numeric',
//                       month: 'short'
//                     })}
//                   </span>
//                 </div>
//               </div>

//               <div className="flex items-center space-x-2 sm:space-x-6">
//                 <a 
//                   href="mailto:contact@xibarubambouck.com" 
//                   className="hidden sm:flex items-center space-x-2 hover:text-white/80 transition-all duration-300 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1 hover:bg-white/20"
//                 >
//                   <EnvelopeIcon className="w-4 h-4" />
//                   <span className="font-medium">Contactez-nous</span>
//                 </a>
//                <div className="flex space-x-3 justify-center sm:justify-start">
//                   <a 
//                     href="https://www.facebook.com/xibarubambouck" 
//                     className="w-7 h-7  rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
//                     aria-label="Facebook"
//                   >
//                     <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">f</span>
//                   </a>
//                   <a 
//                     href="https://api.whatsapp.com/send?phone=221774369394&text&context=AffoSsEX08EdK4TvEUB_dFo3fxt0V8tZAjxL81kqh00KnFdqOnaIRImX5cTDegr2g9XrVsCnHckRwbk0esv0NbUN_wEmFGcpFbq0leVV9clltGjIyKjMKgD4rv3DdsZecmv3lTWLyYEYp8xvhjCNKFsGqg&source&app=facebook" 
//                     className="w-7 h-7  rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
//                     aria-label="WhatsApp"
//                   >
//                     <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">W</span>
//                   </a>
//                   <a 
//                     href="https://www.youtube.com/@user-ij6tn9lu5b" 
//                     className="w-7 h-7  rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
//                     aria-label="YouTube"
//                   >
//                     <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">YT</span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Navigation principale */}
//         <div className="container mx-auto px-4 bg-white">
//           <div className="flex items-center justify-between h-16 sm:h-20">
//             {/* Logo responsive */}
//             <Link to="/" className="flex items-center space-x-2 sm:space-x-3 group">
//               <div className="w-8 h-8 sm:w-12 sm:h-12 bg-gradient-to-r from-red-600 to-blue-800 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
//                 <span className="text-white font-bold text-sm sm:text-xl">XB</span>
//               </div>
//               <div className="hidden sm:block">
//                 <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-red-600 to-blue-800 bg-clip-text text-transparent">
//                   Xibaru Bambouck
//                 </h1>
//                 <p className="text-xs sm:text-sm text-slate-600 font-medium">L'actualité du Bambouck</p>
//               </div>
//               <div className="sm:hidden">
//                 <h1 className="text-lg font-bold bg-gradient-to-r from-red-600 to-blue-800 bg-clip-text text-transparent">
//                   Xibaru Bambouck
//                 </h1>
//               </div>
//             </Link>

//             {/* Navigation desktop */}
//             <nav className="hidden xl:flex items-center space-x-6">
//               <Link 
//                 to="/" 
//                 className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
//               >
//                 Accueil
//                 <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
//               </Link>

//               {/* Menu déroulant Actualités */}
//               <div className="relative group">
//                 <button className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2 flex items-center space-x-1">
//                   <span>Actualités</span>
//                   <ChevronDownIcon className="w-4 h-4 group-hover:rotate-180 transition-transform duration-300" />
//                   <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
//                 </button>

//                 <div className="absolute top-full left-0 mt-2 bg-white shadow-xl rounded-lg border border-slate-100 w-48 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 translate-y-2 transition-all duration-300 z-50">
//                   <Link 
//                     to="/category/politique"
//                     className="block px-4 py-2 text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all first:rounded-t-lg"
//                   >
//                     Politique
//                   </Link>
//                   <Link 
//                     to="/category/societe"
//                     className="block px-4 py-2 text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all"
//                   >
//                     Société
//                   </Link>
//                   <Link 
//                     to="/category/education"
//                     className="block px-4 py-2 text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all last:rounded-b-lg"
//                   >
//                     Éducation
//                   </Link>
//                 </div>
//               </div>

//               <Link
//                 to="/category/religion"
//                 className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
//               >
//                 Religion
//                 <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
//               </Link>

//               <Link
//                 to="/category/necrologie"
//                 className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
//               >
//                 Nécrologie
//                 <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
//               </Link>

//               <Link
//                 to="/category/sport"
//                 className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
//               >
//                 Sport
//                 <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
//               </Link>

//               <Link
//                 to="/category/international"
//                 className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
//               >
//                 International
//                 <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
//               </Link>
//             </nav>

//             {/* Recherche desktop */}
//             <div className="hidden lg:flex items-center">
//               <form onSubmit={handleSearch} className="relative">
//                 <input
//                   type="text"
//                   placeholder="Rechercher..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="w-48 xl:w-72 pl-10 pr-4 py-2 sm:py-3 border-2 border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-300 bg-slate-50 focus:bg-white shadow-sm text-sm"
//                 />
//                 <MagnifyingGlassIcon className="absolute left-3 top-2.5 sm:top-3.5 h-4 w-4 sm:h-5 sm:w-5 text-slate-400" />
//                 <button
//                   type="submit"
//                   className="absolute right-1 top-1 sm:right-2 sm:top-1.5 p-1.5 sm:p-2 bg-gradient-to-r from-red-600 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105"
//                 >
//                   <MagnifyingGlassIcon className="h-3 w-3 sm:h-4 sm:w-4" />
//                 </button>
//               </form>
//             </div>

//             {/* Bouton menu mobile */}
//             <button
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               className="xl:hidden p-2 sm:p-3 rounded-xl text-slate-700 hover:text-red-600 hover:bg-slate-100 transition-all duration-300 border-2 border-transparent hover:border-slate-200"
//             >
//               {isMenuOpen ? (
//                 <XMarkIcon className="h-5 w-5 sm:h-6 sm:w-6" />
//               ) : (
//                 <Bars3Icon className="h-5 w-5 sm:h-6 sm:w-6" />
//               )}
//             </button>
//           </div>

//           {/* Menu mobile responsive */}
//           {isMenuOpen && (
//             <div className="xl:hidden bg-white border-t-2 border-slate-100 shadow-lg">
//               <div className="px-4 pt-4 pb-6 space-y-3">
//                 {/* Recherche mobile */}
//                 <form onSubmit={handleSearch} className="mb-6">
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="Rechercher..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       className="w-full pl-10 pr-4 py-3 border-2 border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-300 bg-slate-50 focus:bg-white text-sm"
//                     />
//                     <MagnifyingGlassIcon className="absolute left-3 top-3.5 h-5 w-5 text-slate-400" />
//                     <button
//                       type="submit"
//                       className="absolute right-2 top-1.5 p-2 bg-gradient-to-r from-red-600 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all duration-300"
//                     >
//                       <MagnifyingGlassIcon className="h-4 w-4" />
//                     </button>
//                   </div>
//                 </form>

//                 {/* Navigation mobile */}
//                 <div className="space-y-2">
//                   <Link
//                     to="/"
//                     className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
//                     onClick={closeMobileMenu}
//                   >
//                     Accueil
//                   </Link>

//                   {/* Actualités avec sous-menu mobile */}
//                   <div className="overflow-hidden">
//                     <button
//                       onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
//                       className="w-full flex items-center justify-between px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
//                     >
//                       <span>Actualités</span>
//                       <ChevronDownIcon 
//                         className={`w-4 h-4 transition-transform duration-300 ${
//                           mobileDropdownOpen ? 'rotate-180' : ''
//                         }`}
//                       />
//                     </button>
                    
//                     <div className={`overflow-hidden transition-all duration-300 ${
//                       mobileDropdownOpen ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
//                     }`}>
//                       <div className="ml-4 mt-2 space-y-1 border-l-2 border-slate-200 pl-4">
//                         <Link
//                           to="/category/politique"
//                           className="block px-4 py-2 text-slate-600 rounded-lg hover:bg-red-50 hover:text-red-600 transition-all duration-300 text-sm"
//                           onClick={closeMobileMenu}
//                         >
//                           Politique
//                         </Link>
//                         <Link
//                           to="/category/societe"
//                           className="block px-4 py-2 text-slate-600 rounded-lg hover:bg-red-50 hover:text-red-600 transition-all duration-300 text-sm"
//                           onClick={closeMobileMenu}
//                         >
//                           Société
//                         </Link>
//                         <Link
//                           to="/category/education"
//                           className="block px-4 py-2 text-slate-600 rounded-lg hover:bg-red-50 hover:text-red-600 transition-all duration-300 text-sm"
//                           onClick={closeMobileMenu}
//                         >
//                           Éducation
//                         </Link>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Autres catégories */}
//                   <Link
//                     to="/category/religion"
//                     className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
//                     onClick={closeMobileMenu}
//                   >
//                     Religion
//                   </Link>

//                   <Link
//                     to="/category/necrologie"
//                     className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
//                     onClick={closeMobileMenu}
//                   >
//                     Nécrologie
//                   </Link>

//                   <Link
//                     to="/category/sport"
//                     className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
//                     onClick={closeMobileMenu}
//                   >
//                     Sport
//                   </Link>

//                   <Link
//                     to="/category/international"
//                     className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
//                     onClick={closeMobileMenu}
//                   >
//                     International
//                   </Link>
//                 </div>

//                 {/* Réseaux sociaux mobile */}
//                 <div className="pt-4 mt-6 border-t-2 border-slate-100">
//                   <p className="text-sm font-semibold text-slate-600 mb-3">Suivez-nous</p>
//                   <div className="flex space-x-3 justify-center sm:justify-start">
//                   <a 
//                     href="https://www.facebook.com/xibarubambouck" 
//                     className="w-10 h-10 bg-gradient-to-r from-blue-600 to-blue-700 rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
//                     aria-label="Facebook"
//                   >
//                     <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">f</span>
//                   </a>
//                   <a 
//                     href="https://api.whatsapp.com/send?phone=221774369394&text&context=AffoSsEX08EdK4TvEUB_dFo3fxt0V8tZAjxL81kqh00KnFdqOnaIRImX5cTDegr2g9XrVsCnHckRwbk0esv0NbUN_wEmFGcpFbq0leVV9clltGjIyKjMKgD4rv3DdsZecmv3lTWLyYEYp8xvhjCNKFsGqg&source&app=facebook" 
//                     className="w-10 h-10 bg-gradient-to-r from-green-600 to-green-700 rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
//                     aria-label="WhatsApp"
//                   >
//                     <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">W</span>
//                   </a>
//                   <a 
//                     href="https://www.youtube.com/@user-ij6tn9lu5b" 
//                     className="w-10 h-10 bg-gradient-to-r from-red-600 to-red-700 rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
//                     aria-label="YouTube"
//                   >
//                     <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">YT</span>
//                   </a>
//                 </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </header>

//       {/* Breadcrumbs */}
//       {location.pathname !== '/' && (
//         <div className="bg-slate-50 border-b border-slate-200 mt-20 sm:mt-24">
//           <div className="container mx-auto px-4 py-3">
//             <nav className="flex items-center space-x-2 text-sm">
//               {generateBreadcrumbs().map((breadcrumb, index) => (
//                 <React.Fragment key={breadcrumb.path}>
//                   {index > 0 && (
//                     <ChevronRightIcon className="w-4 h-4 text-slate-400" />
//                   )}
//                   <Link
//                     to={breadcrumb.path}
//                     className={`${
//                       index === generateBreadcrumbs().length - 1
//                         ? 'text-red-600 font-semibold'
//                         : 'text-slate-600 hover:text-red-600'
//                     } transition-colors duration-200`}
//                   >
//                     {breadcrumb.name}
//                   </Link>
//                 </React.Fragment>
//               ))}
//             </nav>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Header;

import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { 
  MagnifyingGlassIcon, 
  Bars3Icon, 
  XMarkIcon,
  CalendarDaysIcon,
  EnvelopeIcon,
  GlobeAltIcon,
  UserGroupIcon,
  ChevronDownIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline';
import { useCategories } from '../../hooks/useCategories';
import udam from '../../images/udam.jpg';
import acep from '../../images/acep.jpg';
import nsia from '../../images/nsia.jpg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { categories, loading: categoriesLoading } = useCategories();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
      setSearchTerm('');
      setIsMenuOpen(false);
    }
  };

  const mainCategories = categories.filter(cat => cat.parent === 0).slice(0, 6);

  // Partenaires pour le carrousel
  const partners = [
    { id: 1, name: "UDAM", logo: udam },
    { id: 2, name: "ACEP", logo: acep },
    { id: 3, name: "NSIA", logo: nsia },

  ];

  // Dupliquer pour l'effet de boucle infinie
  const duplicatedPartners = [...partners, ...partners, ...partners];

  // Fonction pour générer les breadcrumbs
  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [];

    if (pathSegments.length > 0) {
      if (pathSegments[0] === 'category' && pathSegments[1]) {
        const categoryName = pathSegments[1];
        const categoryDisplayName = getCategoryDisplayName(categoryName);
        breadcrumbs.push({
          name: categoryDisplayName,
          path: `/category/${categoryName}`
        });
      }
    }

    return breadcrumbs;
  };

  const getCategoryDisplayName = (categorySlug) => {
    const categoryMap = {
      'politique': 'Politique',
      'societe': 'Société',
      'education': 'Éducation',
      'religion': 'Religion',
      'necrologie': 'Nécrologie',
      'sport': 'Sport',
      'international': 'International'
    };
    return categoryMap[categorySlug] || categorySlug;
  };

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
    setMobileDropdownOpen(false);
  };

  return (
    <>
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        .animate-scroll {
          animation: scroll 15s linear infinite;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
      
      <header className="bg-white shadow-lg fixed w-full top-0 z-50">
        {/* <header className="bg-white shadow-lg w-full z-50"> */}

        {/* Section partenaires avec carrousel */}
<div className="bg-gray-50 py-2 shadow-sm overflow-hidden">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex animate-scroll space-x-8">
      {/* Dupliquer les partenaires pour l'effet de boucle */}
      {[...Array(3)].flatMap((_, groupIndex) => [
        <div key={`udam-${groupIndex}`} className="flex-shrink-0">
          <img
            src={udam}
            alt="Logo UDAM"
            className="w-32 h-16 sm:w-24 sm:h-20 object-contain transition-all duration-300 cursor-pointer hover:scale-105"
          />
        </div>,
        <div key={`acep-${groupIndex}`} className="flex-shrink-0">
          <a
            href=""
            target="_blank"
            rel="noopener noreferrer"
            className="block transition-all duration-300 hover:scale-105"
          >
            <img
              src={udam}
              alt="Logo ACEP"
              className="w-40 h-16 sm:w-32 sm:h-20 object-contain cursor-pointer"
            />
            
          </a>
        </div>,

        <div key={`nsia-${groupIndex}`} className="flex-shrink-0">
          <img
            src={udam}
            alt="Logo NSIA"
            className="w-32 h-16 sm:w-24 sm:h-20 object-contain transition-all duration-300 cursor-pointer hover:scale-105"
          />
        </div>
        
      ])}
    </div>
  </div>
</div>



        <div className="bg-gradient-to-r from-red-600 via-red-700 to-blue-800 text-white">
          <div className="container mx-auto px-4 py-2 sm:py-3">
            <div className="flex justify-between items-center text-xs sm:text-sm">
              <div className="flex items-center space-x-2 sm:space-x-6">
                <div className="flex items-center space-x-1 sm:space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-2 sm:px-3 py-1">
                  <CalendarDaysIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                  <span className="font-medium hidden sm:inline">
                    {new Date().toLocaleDateString('fr-FR', { 
                      weekday: 'long', 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </span>
                  <span className="font-medium sm:hidden">
                    {new Date().toLocaleDateString('fr-FR', { 
                      day: 'numeric',
                      month: 'short'
                    })}
                  </span>
                </div>
              </div>

              <div className="flex items-center space-x-2 sm:space-x-6">
                <a 
                  href="mailto:contact@xibarubambouck.com" 
                  className="hidden sm:flex items-center space-x-2 hover:text-white/80 transition-all duration-300 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1 hover:bg-white/20"
                >
                  <EnvelopeIcon className="w-4 h-4" />
                  <span className="font-medium">Contactez-nous</span>
                </a>
               <div className="flex space-x-3 justify-center sm:justify-start">
                  <a 
                    href="https://www.facebook.com/xibarubambouck" 
                    className="w-7 h-7  rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
                    aria-label="Facebook"
                  >
                    <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">f</span>
                  </a>
                  <a 
                    href="https://api.whatsapp.com/send?phone=221774369394&text&context=AffoSsEX08EdK4TvEUB_dFo3fxt0V8tZAjxL81kqh00KnFdqOnaIRImX5cTDegr2g9XrVsCnHckRwbk0esv0NbUN_wEmFGcpFbq0leVV9clltGjIyKjMKgD4rv3DdsZecmv3lTWLyYEYp8xvhjCNKFsGqg&source&app=facebook" 
                    className="w-7 h-7  rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
                    aria-label="WhatsApp"
                  >
                    <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">W</span>
                  </a>
                  <a 
                    href="https://www.youtube.com/@user-ij6tn9lu5b" 
                    className="w-7 h-7  rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
                    aria-label="YouTube"
                  >
                    <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">YT</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation principale */}
        <div className="container mx-auto px-4 bg-white">
          <div className="flex items-center justify-between h-16 sm:h-20">
            {/* Logo responsive */}
            <Link to="/" className="flex items-center space-x-2 sm:space-x-3 group">
              <div className="w-8 h-8 sm:w-12 sm:h-12 bg-gradient-to-r from-red-600 to-blue-800 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
                <span className="text-white font-bold text-sm sm:text-xl">XB</span>
              </div>
              <div className="hidden sm:block">
                <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-red-600 to-blue-800 bg-clip-text text-transparent">
                  Xibaru Bambouck
                </h1>
                <p className="text-xs sm:text-sm text-slate-600 font-medium">L'actualité du Bambouck</p>
              </div>
              <div className="sm:hidden">
                <h1 className="text-lg font-bold bg-gradient-to-r from-red-600 to-blue-800 bg-clip-text text-transparent">
                  Xibaru Bambouck
                </h1>
              </div>
            </Link>

            {/* Navigation desktop */}
            <nav className="hidden xl:flex items-center space-x-6">
              <Link 
                to="/" 
                className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
              >
                Accueil
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
              </Link>

              {/* Menu déroulant Actualités */}
              <div className="relative group">
                <button className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2 flex items-center space-x-1">
                  <span>Actualités</span>
                  <ChevronDownIcon className="w-4 h-4 group-hover:rotate-180 transition-transform duration-300" />
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
                </button>

                <div className="absolute top-full left-0 mt-2 bg-white shadow-xl rounded-lg border border-slate-100 w-48 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 translate-y-2 transition-all duration-300 z-50">
                  <Link 
                    to="/category/politique"
                    className="block px-4 py-2 text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all first:rounded-t-lg"
                  >
                    Politique
                  </Link>
                  <Link 
                    to="/category/societe"
                    className="block px-4 py-2 text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all"
                  >
                    Société
                  </Link>
                  <Link 
                    to="/category/education"
                    className="block px-4 py-2 text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all last:rounded-b-lg"
                  >
                    Éducation
                  </Link>
                </div>
              </div>

              <Link
                to="/category/religion"
                className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
              >
                Religion
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
              </Link>

              <Link
                to="/category/necrologie"
                className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
              >
                Nécrologie
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
              </Link>

              <Link
                to="/category/sport"
                className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
              >
                Sport
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
              </Link>

              <Link
                to="/category/international"
                className="text-slate-700 hover:text-red-600 font-semibold transition-all duration-300 relative group py-2"
              >
                International
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-blue-800 transition-all duration-300 group-hover:w-full"></span>
              </Link>
            </nav>

            {/* Recherche desktop */}
            <div className="hidden lg:flex items-center">
              <form onSubmit={handleSearch} className="relative">
                <input
                  type="text"
                  placeholder="Rechercher..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-48 xl:w-72 pl-10 pr-4 py-2 sm:py-3 border-2 border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-300 bg-slate-50 focus:bg-white shadow-sm text-sm"
                />
                <MagnifyingGlassIcon className="absolute left-3 top-2.5 sm:top-3.5 h-4 w-4 sm:h-5 sm:w-5 text-slate-400" />
                <button
                  type="submit"
                  className="absolute right-1 top-1 sm:right-2 sm:top-1.5 p-1.5 sm:p-2 bg-gradient-to-r from-red-600 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105"
                >
                  <MagnifyingGlassIcon className="h-3 w-3 sm:h-4 sm:w-4" />
                </button>
              </form>
            </div>

            {/* Bouton menu mobile */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="xl:hidden p-2 sm:p-3 rounded-xl text-slate-700 hover:text-red-600 hover:bg-slate-100 transition-all duration-300 border-2 border-transparent hover:border-slate-200"
            >
              {isMenuOpen ? (
                <XMarkIcon className="h-5 w-5 sm:h-6 sm:w-6" />
              ) : (
                <Bars3Icon className="h-5 w-5 sm:h-6 sm:w-6" />
              )}
            </button>
          </div>

          {/* Menu mobile responsive */}
          {isMenuOpen && (
            <div className="xl:hidden bg-white border-t-2 border-slate-100 shadow-lg">
              <div className="px-4 pt-4 pb-6 space-y-3">
                {/* Recherche mobile */}
                <form onSubmit={handleSearch} className="mb-6">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Rechercher..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full pl-10 pr-4 py-3 border-2 border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-300 bg-slate-50 focus:bg-white text-sm"
                    />
                    <MagnifyingGlassIcon className="absolute left-3 top-3.5 h-5 w-5 text-slate-400" />
                    <button
                      type="submit"
                      className="absolute right-2 top-1.5 p-2 bg-gradient-to-r from-red-600 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all duration-300"
                    >
                      <MagnifyingGlassIcon className="h-4 w-4" />
                    </button>
                  </div>
                </form>

                {/* Navigation mobile */}
                <div className="space-y-2">
                  <Link
                    to="/"
                    className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
                    onClick={closeMobileMenu}
                  >
                    Accueil
                  </Link>

                  {/* Actualités avec sous-menu mobile */}
                  <div className="overflow-hidden">
                    <button
                      onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                      className="w-full flex items-center justify-between px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
                    >
                      <span>Actualités</span>
                      <ChevronDownIcon 
                        className={`w-4 h-4 transition-transform duration-300 ${
                          mobileDropdownOpen ? 'rotate-180' : ''
                        }`}
                      />
                    </button>
                    
                    <div className={`overflow-hidden transition-all duration-300 ${
                      mobileDropdownOpen ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                    }`}>
                      <div className="ml-4 mt-2 space-y-1 border-l-2 border-slate-200 pl-4">
                        <Link
                          to="/category/politique"
                          className="block px-4 py-2 text-slate-600 rounded-lg hover:bg-red-50 hover:text-red-600 transition-all duration-300 text-sm"
                          onClick={closeMobileMenu}
                        >
                          Politique
                        </Link>
                        <Link
                          to="/category/societe"
                          className="block px-4 py-2 text-slate-600 rounded-lg hover:bg-red-50 hover:text-red-600 transition-all duration-300 text-sm"
                        >
                          Société
                        </Link>
                        <Link
                          to="/category/education"
                          className="block px-4 py-2 text-slate-600 rounded-lg hover:bg-red-50 hover:text-red-600 transition-all duration-300 text-sm"
                          onClick={closeMobileMenu}
                        >
                          Éducation
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* Autres catégories */}
                  <Link
                    to="/category/religion"
                    className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
                    onClick={closeMobileMenu}
                  >
                    Religion
                  </Link>

                  <Link
                    to="/category/necrologie"
                    className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
                    onClick={closeMobileMenu}
                  >
                    Nécrologie
                  </Link>

                  <Link
                    to="/category/sport"
                    className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
                    onClick={closeMobileMenu}
                  >
                    Sport
                  </Link>

                  <Link
                    to="/category/international"
                    className="block px-4 py-3 text-slate-700 hover:text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-blue-50 rounded-xl font-semibold transition-all duration-300 border-l-4 border-transparent hover:border-red-600"
                    onClick={closeMobileMenu}
                  >
                    International
                  </Link>
                </div>

                {/* Réseaux sociaux mobile */}
                <div className="pt-4 mt-6 border-t-2 border-slate-100">
                  <p className="text-sm font-semibold text-slate-600 mb-3">Suivez-nous</p>
                  <div className="flex space-x-3 justify-center sm:justify-start">
                  <a 
                    href="https://www.facebook.com/xibarubambouck" 
                    className="w-10 h-10 bg-gradient-to-r from-blue-600 to-blue-700 rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
                    aria-label="Facebook"
                  >
                    <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">f</span>
                  </a>
                  <a 
                    href="https://api.whatsapp.com/send?phone=221774369394&text&context=AffoSsEX08EdK4TvEUB_dFo3fxt0V8tZAjxL81kqh00KnFdqOnaIRImX5cTDegr2g9XrVsCnHckRwbk0esv0NbUN_wEmFGcpFbq0leVV9clltGjIyKjMKgD4rv3DdsZecmv3lTWLyYEYp8xvhjCNKFsGqg&source&app=facebook" 
                    className="w-10 h-10 bg-gradient-to-r from-green-600 to-green-700 rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
                    aria-label="WhatsApp"
                  >
                    <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">W</span>
                  </a>
                  <a 
                    href="https://www.youtube.com/@user-ij6tn9lu5b" 
                    className="w-10 h-10 bg-gradient-to-r from-red-600 to-red-700 rounded-full flex items-center justify-center hover:shadow-lg transition-all duration-300 hover:scale-110 group"
                    aria-label="YouTube"
                  >
                    <span className="text-white text-sm font-bold group-hover:scale-110 transition-transform">YT</span>
                  </a>
                </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Breadcrumbs */}
      {location.pathname !== '/' && (
        <div className="bg-slate-50 border-b border-slate-200 mt-20 sm:mt-24">
          <div className="container mx-auto px-4 py-3">
            <nav className="flex items-center space-x-2 text-sm">
              {generateBreadcrumbs().map((breadcrumb, index) => (
                <React.Fragment key={breadcrumb.path}>
                  {index > 0 && (
                    <ChevronRightIcon className="w-4 h-4 text-slate-400" />
                  )}
                  <Link
                    to={breadcrumb.path}
                    className={`${
                      index === generateBreadcrumbs().length - 1
                        ? 'text-red-600 font-semibold'
                        : 'text-slate-600 hover:text-red-600'
                    } transition-colors duration-200`}
                  >
                    {breadcrumb.name}
                  </Link>
                </React.Fragment>
              ))}
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;